// extracted by mini-css-extract-plugin
module.exports = {"triangle":"PopUp_triangle__3WkCx","popup":"PopUp_popup__1N78z","hidden":"PopUp_hidden__h1vAv"};